<template>
  <div>
    <custom-filters
      class="d-flex justify-space-around"
      namespace="sensors"
      i18n-path="sensors"
      style="height: 96px; overflow-y: auto"
    />
    <v-data-table
      v-if="frontSort"
      dense
      multi-sort
      hide-default-footer
      fixed-header
      :items-per-page="data.length"
      calculate-widths
      :headers="headers"
      v-bind="$attrs"
      :items="data"
      :loading="loading"
      :height="height - 96 + 'px'"
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:item.valid_nomenclature="{ item }">
        <display-icon-badge-tooltip
          icon="fiber_manual_record"
          :icon-color="item.valid_nomenclature === 1 ? 'success' : 'grey'"
        />
      </template>
      <template v-slot:item.temperature_meter="{ item }">
        <div v-if="item.temperature_meter === 1">Oui</div>
        <div v-else-if="item.temperature_meter === 0">Non</div>
        <div v-else>Non précisé</div>
      </template>
      <template v-slot:top>
        <div class="d-flex justify-space-between">
          <div class="primary--text font-weight-bold ml-10 my-1">
            Liste Sondes
          </div>
          <v-checkbox
            dense
            label="Tri sur la page"
            v-model="frontSort"
            class="my-1 mr-10"
          ></v-checkbox>
          <custom-page-selector class="pa-2" namespace="sensors" />
        </div>
      </template>
    </v-data-table>
    <v-data-table
      v-else
      dense
      hide-default-footer
      fixed-header
      calculate-widths
      :headers="headers"
      :server-items-length="data.length"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDESC"
      v-bind="$attrs"
      :items="data"
      :loading="loading"
      :height="height - 96 + 'px'"
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:item.valid_nomenclature="{ item }">
        <display-icon-badge-tooltip
          icon="fiber_manual_record"
          :icon-color="item.valid_nomenclature === 1 ? 'success' : 'grey'"
        />
      </template>
      <template v-slot:item.temperature_meter="{ item }">
        <div v-if="item.temperature_meter === 1">Oui</div>
        <div v-else-if="item.temperature_meter === 0">Non</div>
        <div v-else>Non précisé</div>
      </template>
      <template v-slot:top>
        <div class="d-flex justify-space-between">
          <div class="primary--text font-weight-bold ml-10 my-1">
            Liste Sondes
          </div>
          <v-checkbox
            dense
            label="Tri sur la page"
            v-model="frontSort"
            class="my-1 mr-10"
          ></v-checkbox>
          <custom-page-selector class="pa-2" namespace="sensors" />
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import sortable from '@/business/mixins/sortable';
import DisplayIconBadgeTooltip from '@/components/displays/DisplayIconBadgeTooltip';
import CustomFilters from '@/components/tools/CustomFilters';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'SensorsTable',
  mixins: [sortable],
  components: { CustomFilters, DisplayIconBadgeTooltip, CustomPageSelector },
  methods: {
    generateMessage,
  },
  props: {
    height: Number,
  },
  data() {
    return {
      headers: [
        {
          text: this.generateMessage('sensors.fields.valid_nomenclature'),
          value: 'valid_nomenclature',
        },
        {
          text: this.generateMessage('sensors.fields.temperature_meter'),
          value: 'temperature_meter',
        },
        { text: this.generateMessage('sensors.fields.type'), value: 'type' },
        {
          text: this.generateMessage('sensors.fields.meter_property_name'),
          value: 'meter_property_name',
        },
        { text: this.generateMessage('sensors.fields.label'), value: 'label' },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
      namespace: 'sensors',
      frontSort: false,
    };
  },
  computed: {
    ...mapGetters({
      data: 'sensors/items',
      loading: 'sensors/isLoadingItems',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
